import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mail, MessageSquare, Phone, MapPin } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const set = e => setForm({ ...form, [e.target.name]: e.target.value });
  const submit = async e => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await axios.post(`${API}/contact`, form);
      setSent(true);
    } catch (e2) {
      setErr(e2.response?.data?.detail || e2.message || "Could not send. Please email info@goprintpack.com directly.");
    } finally { setBusy(false); }
  };

  return (
    <div className="marketing">
      <header className="m-nav" data-testid="contact-navbar">
        <Link to="/" className="m-brand"><img src="/logo.png" alt="GoPrintPack" style={{ height: 32 }}/></Link>
        <nav className="m-nav-links">
          <Link to="/">Home</Link>
          <Link to="/contact">Contact</Link>
        </nav>
        <div className="m-nav-actions">
          <Link to="/login" className="m-ghost" data-testid="nav-sign-in">Sign in</Link>
          <Link to="/register" className="m-cta" data-testid="nav-launch-workspace">Get started</Link>
        </div>
      </header>

      <section className="contact-page" data-testid="contact-page">
        <div className="contact-hero">
          <p className="eyebrow">CONTACT US</p>
          <h1>Let's talk printing & packaging.</h1>
          <p className="subhead">Questions about pricing, supplier onboarding, buyer protection, or a specific run you're planning? Drop us a line and our team will get back within one business day.</p>
        </div>

        <div className="contact-grid">
          <div className="contact-info">
            <h3>Reach us directly</h3>
            <div className="contact-info-row" data-testid="contact-email">
              <Mail size={17}/>
              <div>
                <label>Email</label>
                <a href="mailto:info@goprintpack.com"><b>info@goprintpack.com</b></a>
              </div>
            </div>
            <div className="contact-info-row" data-testid="contact-support">
              <MessageSquare size={17}/>
              <div>
                <label>Support</label>
                <span>Every request answered in &lt; 1 business day</span>
              </div>
            </div>
            <div className="contact-info-row" data-testid="contact-hours">
              <Phone size={17}/>
              <div>
                <label>Hours</label>
                <span>Mon–Fri · 9am – 7pm IST</span>
              </div>
            </div>
            <div className="contact-info-row" data-testid="contact-address">
              <MapPin size={17}/>
              <div>
                <label>Address</label>
                <span>GoPrintPack HQ : Survey No 312/1, Kokamthan, Dist-Ahilyanagar, State-Maharashtra, India. Pin - 423601.</span>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={submit} data-testid="contact-form">
            {sent ? (
              <div className="contact-success" data-testid="contact-success">
                <h3>Thanks — we've received your message.</h3>
                <p>Our team will reply to <b>{form.email}</b> within one business day. In the meantime, feel free to email <a href="mailto:info@goprintpack.com">info@goprintpack.com</a> directly.</p>
              </div>
            ) : (
              <>
                <h3>Send us a message</h3>
                <label>Full name
                  <input data-testid="contact-name" name="name" value={form.name} onChange={set} required minLength={2}/>
                </label>
                <label>Email
                  <input data-testid="contact-email-input" type="email" name="email" value={form.email} onChange={set} required/>
                </label>
                <label>Company (optional)
                  <input data-testid="contact-company" name="company" value={form.company} onChange={set}/>
                </label>
                <label>Message
                  <textarea data-testid="contact-message" name="message" value={form.message} onChange={set} required minLength={10} rows={5} placeholder="Tell us about your print/packaging needs, timeline, quantities…"/>
                </label>
                {err && <div className="auth-error" data-testid="contact-error">{err}</div>}
                <button data-testid="contact-submit" className="primary-btn full" disabled={busy}>
                  {busy ? "Sending…" : "Send message"}
                </button>
                <small>By submitting, you agree to be contacted about your enquiry. We never share your data.</small>
              </>
            )}
          </form>
        </div>
      </section>

      <footer className="m-footer">
        <div className="m-footer-row">
          <span>© {new Date().getFullYear()} GoPrintPack™ · A smart platform for print & packaging</span>
          <div className="m-footer-links">
            <Link to="/contact">Contact us</Link>
            <a href="mailto:info@goprintpack.com">info@goprintpack.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
